<template>
  <div class="footer-container">
    <div class="link-content">
      <div class="contact">
        <span class="pointer" @click="goToPage('/contact')">{{ $t('footer.contactUs') }}</span>
        <span class="pointer" @click="goToPage('/map')">{{ $t('footer.siteMap') }}</span>
      </div>
<!--      <div class="lang">-->
<!--        <span class="pointer" :class="{ active: locale === 'zh' }" @click="switchLang('zh')">{{ $t('footer.langZh')-->
<!--          }}</span>-->
<!--        <span class="pointer" :class="{ active: locale === 'en' }" @click="switchLang('en')">{{ $t('footer.langEn')-->
<!--          }}</span>-->
<!--      </div>-->
    </div>
    <div class="info-content">
      <div>Copyright Right © 2025 苏州正雄企业发展有限公司</div>
      <div>备案号：苏ICP备1*******号</div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    locale() {
      return this.$i18n.locale;
    }
  },
  methods: {
    goToPage(path) {
      this.$router.push(path);
    },
    switchLang(lang) {
      if (lang === this.locale) return;
      // this.$i18n.locale = lang;
      // if (typeof localStorage !== 'undefined') {
      //   localStorage.setItem('lang', lang);
      // }
      // if (typeof document !== 'undefined') {
      //   document.documentElement.setAttribute('lang', lang);
      // }
    }
  }
};
</script>

<style scoped lang="scss">
.footer-container {
  width: 100%;
}

.link-content {
  background: #fff;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 12.45vw;
  padding-right: 13.39vw;
  color: #71151A;
  border-top: 1px solid #71151A;
  font-size: var(--fs-body-sm);
  line-height: var(--lh-tight);

  .contact {
    span {
      margin-right: 6.25vw;
    }
  }
}

.lang {
  width: 191px;
  height: 36px;
  border: 1px solid #71151A;
  display: flex;
  align-items: center;
  font-size: var(--fs-body-sm);
  line-height: var(--lh-tight);

  span {
    flex: 1;
    text-align: center;

    //&.active {
    //  background: #71151A;
    //  color: #fff;
    //}
    &:first-child {
      border-right: 1px solid #71151A;
    }
  }
}

.info-content {
  background: #71151A;
  height: 46px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 12.5vw;
  padding-right: 13.49vw;
  font-size: var(--fs-body-sm);
  line-height: var(--lh-tight);
}

@media (orientation: portrait) {

  .link-content,
  .info-content {
    padding-left: 1vw;
    padding-right: 1vw;
  }

}
</style>
